import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';

import axiosApi, {
  AxiosError,
  AxiosRequestHeaders,
  type AxiosRequestConfig,
} from '@mint-lib/api';

type BaseQueryParams = {
  url: string;
  method?: AxiosRequestConfig['method'];
  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
  headers?: AxiosRequestHeaders;
};

export const BASE_URL = '/api/datintell/v1/';

type AxiosBaseQueryOptions = {
  baseUrl: string;
};

const DEFAULT_AXIOS_BASE_QUERY_OPTIONS: AxiosBaseQueryOptions = {
  baseUrl: '',
};

export const axiosBaseQuery =
  ({
    baseUrl,
  }: AxiosBaseQueryOptions = DEFAULT_AXIOS_BASE_QUERY_OPTIONS): BaseQueryFn<
    BaseQueryParams,
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }: BaseQueryParams) => {
    try {
      const result = await axiosApi.request({
        url,
        method,
        data,
        params,
        headers,
        baseURL: baseUrl,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({ baseUrl: BASE_URL }),
  endpoints: () => ({}),
  keepUnusedDataFor: 5,
  tagTypes: [
    'BuilderView',
    'MediaPlans',
    'MediaPlanInfo',
    'MediaPlanMeta',
    'MediaPlanVersions',
    'MediaPlanVersion',
  ],
});
